import { render, staticRenderFns } from "./activateInfo.vue?vue&type=template&id=5c245f3a&scoped=true"
import script from "./activateInfo.vue?vue&type=script&lang=js"
export * from "./activateInfo.vue?vue&type=script&lang=js"
import style0 from "./activateInfo.vue?vue&type=style&index=0&id=5c245f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c245f3a",
  null
  
)

export default component.exports